import React from 'react'
import { Button, Container, Divider, Form, Message } from 'semantic-ui-react'

import AuthenticationShell from 'shared/components/AuthenticationShell'
import Page from 'shared/components/Page'
import Title from 'shared/components/Title'

export default function TwoFactorLoginPage({ otp, onOtpChange, errorMessage, verifyOtp, loading }) {
  function handleSubmit(e) {
    e.preventDefault()
    verifyOtp(otp)
  }

  function handleOtpChange(_, { value }) {
    onOtpChange(value)
  }

  return (
    <Page>
      <Title title="Two-factor authentication" />
      <AuthenticationShell
        headerText={
          <>
            <i className="far fa-lock icon" /> Two-factor authentication
          </>
        }
      >
        <Form onSubmit={handleSubmit}>
          {errorMessage && (
            <Message negative data-robot="login-error">
              <strong>Whoops!</strong> {errorMessage}
            </Message>
          )}
          <Form.Field>
            <Form.Input label="Authentication code" onChange={handleOtpChange} autoFocus />
          </Form.Field>
          <VerifyButton loading={loading} />
        </Form>
        <Container textAlign="center">
          <Divider hidden />
          <p>
            Open the two-factor authentication app on your device to view your authentication code
            and verify your identity.
          </p>
          <p>
            <a
              href="https://help.simplesat.io/en/articles/3934073-about-two-factor-authentication"
              target="_blank"
              rel="noreferrer"
            >
              Learn more or get help
            </a>
          </p>
        </Container>
      </AuthenticationShell>
    </Page>
  )
}

function VerifyButton({ loading }) {
  return (
    <Button fluid primary disabled={loading}>
      <span className="text-white">{loading ? 'Verifying...' : 'Verify'}</span>
    </Button>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/TwoFactorLogin/index.js